import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DocumentService } from '@app/core/services/document/document.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-document-application-list',
    templateUrl: './document-application-list.component.html',
    styleUrls: ['./document-application-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class DocumentApplicationListComponent implements OnInit {
    constructor(
        public documentService: DocumentService,
        public toolService: ToolService,
        private title: Title,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {}

    myDocuments = this.documentService.applicationDocumentsDetails();
    //
    myApplications: any;
    myApplicationsReady: boolean = false;

    ngOnInit() {
        // set title
        this.title.setTitle('AMOpportunities - Application Documents');
        // get applications completed and active
        this.myDocuments.subscribe((docs: any) => {
            this.myApplications = [...docs.data.activeApplications, ...docs.data.completeApplications]; // from(applicationArray);
            this.myApplicationsReady = true;
        });
    }
}
